import { useUserRole } from "@/api";
import Loading from "@/components/ui/loading";
import { AccessDenied } from "@/features/access-denied";
import { ComponentType, FC, ReactNode } from "react";

export function requireAdmin<P extends object>(
  Component: ComponentType<P>
): FC<P> {
  return function RequireAdmin(props: P): ReactNode {
    const { isAdmin, loading } = useUserRole();

    if (loading)
      return (
        <div className="w-full h-screen flex items-center justify-center">
          <Loading size="sm" />
        </div>
      );

    if (!isAdmin) return <AccessDenied />;

    return <Component {...props} />;
  };
}
